import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import {
  permissionListQueryOptions,
  roleListQueryOptions,
} from '@/modules/role/role.hooks'

export const rolesRoute = createRoute({
  path: '/roles',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const rolesListRoute = createRoute({
  getParentRoute: () => rolesRoute,
  path: '/',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'role.list',
      'Rol listesine erişim izniniz yok.'
    ),
  loader: () => queryClient.ensureQueryData(roleListQueryOptions()),
  head: () => ({ meta: [{ title: 'Roller' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/role/pages/list-role.page')
  ),
})

export const rolesCreateRoute = createRoute({
  getParentRoute: () => rolesRoute,
  path: 'create',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'role.create',
      'Rol oluşturmak için yetkiniz yok.'
    ),
  loader: () => queryClient.ensureQueryData(permissionListQueryOptions()),
  head: () => ({ meta: [{ title: 'Rol Oluştur' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/role/pages/create-role.page')
  ),
})

export const rolesDetailRoute = createRoute({
  getParentRoute: () => rolesRoute,
  path: '$id',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'role.list',
      'Rol detayına erişim izniniz yok.'
    ),
  loader: () =>
    Promise.all([
      queryClient.ensureQueryData(roleListQueryOptions()),
      queryClient.ensureQueryData(permissionListQueryOptions()),
    ]),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/role/pages/detail-role.page')
  ),
})

export const rolesEditRoute = createRoute({
  getParentRoute: () => rolesRoute,
  path: '$id/edit',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'role.update',
      'Rol düzenlemek için yetkiniz yok.'
    ),
  loader: () =>
    Promise.all([
      queryClient.ensureQueryData(roleListQueryOptions()),
      queryClient.ensureQueryData(permissionListQueryOptions()),
    ]),
  head: () => ({ meta: [{ title: 'Rol Düzenle' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/role/pages/edit-role.page')
  ),
})
